import { booleanInputsListFlat as bool } from "./checkbox";
import { classificationTypeListFlat as classification } from "./classification";
import { numberInputsListFlat as number } from "./number";
import { statusListFlat as status } from "./status";
import { textInputsListFlat as text } from "./text";
import type React from "react";
import { createContext } from "react";
import type { updateValuesInterface } from "./display";
import type { InventoryListingConfig } from "@dealer-center/ddc-pages-inventory-config-interface";

export type itemsWithComponents = Record<string, React.ReactNode>;

export const allControls = [
  ...Object.values(text),
  ...Object.values(bool),
  ...Object.values(number),
  ...Object.values(classification),
  ...Object.values(status)
];

export type allControlsKeys = keyof typeof allControls;

export interface configItemContextInterface {
  setIsNewConfig: (value: boolean) => void;
  isNewConfig: boolean;
  curentConfig: InventoryListingConfig;
  setCurrentConfigValue: (config: updateValuesInterface) => void;
  selectedConfig: InventoryListingConfig;
  setSelectedConfigName: (value: string) => void;
  selectedConfigName: string;
  importedConfig?: InventoryListingConfig;
  setImportedConfig: (value: InventoryListingConfig) => void;
  resetConfig: () => void;
}

export const configItemContext = createContext<configItemContextInterface>(
  {} as configItemContextInterface
);
// https://ghe.coxautoinc.com/DDC-CoreFeatures/core/blob/39523bdde09a9d4f53f9e49f125f860fbcd91e37/src/resources/inventory-listing-config-defaults.json
